import { Box } from "@mui/material";

export default function StockCountCardShell({ children, sx }) {
  return (
    <Box
      sx={{
        p: 2,
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
        bgcolor: "neutral.50",
        borderRadius: "30px",
        border: "1px solid rgba(0,0,0,.06)",
        boxShadow: "0px 8px 24px rgba(23, 31, 76, 0.06)",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
